
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as homem0g0HAU4E3Tkkq5oyQoK130gU7KOFNmgwkcQO19p9YMMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/home.vue?macro=true";
import { default as testp1bpQmn4QHezmkb_R9N6HSI4w4dFGmJEpD8EdA9_4555EMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/test.vue?macro=true";
import { default as index3AXRhqO1FEMlMLVGva0VByziiu7Jndbaw7tAOBw_0mgMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/index.vue?macro=true";
import { default as loginV8l6ltEd1rmlEstalWRa7j_45BGxpJ8P_458PITF7px0WfIMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/login.vue?macro=true";
import { default as termsaElukA62qOaMMgjlXifX25Zh62UIhaPxv8_aAP1ACnkMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/terms.vue?macro=true";
import { default as editorC0QRbTI7LnsL9V9TnLs6lNUMPc_DLxNC_455ZJ37ijHUwMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/editor.vue?macro=true";
import { default as signuprVmd_45kGsgPNui1ZUWaAn6hQWyNuRzzG4OqnBxNVf0t8Meta } from "/vercel/path0/packages/ddc-giving-circle/pages/signup.vue?macro=true";
import { default as profiler_45ATncfblxG8TF6VeYJXVoHYB5m7LdwgwCPsUSfdfLwMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/profile.vue?macro=true";
import { default as indexZT6loCysMcrsC4HwlrYdrvhiJjmG_U8zLq0y3MpE1VYMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/index.vue?macro=true";
import { default as share1XnIuhLeY9LUuJaFeLrFtosdzEsHWXA94jHklFXXffwMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/share.vue?macro=true";
import { default as prizesKH0yayYJqJhqq61K3HXPCM_45ML2vp22VnOKDrm8PPmGQMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/prizes.vue?macro=true";
import { default as membersll3o2XWHaqLcNCOlJ5nvwLfuolSEo7u_45pJgqQEfB_0oMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/members.vue?macro=true";
import { default as partners9rra4VRy9v10qblSI69858r7IdEjFJncxMxPp_45L5F2AMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/partners.vue?macro=true";
import { default as settingsL5R9uGXo0n9ySdrMRtiOw9bTyU9Jqcac8rEj98e7vPoMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/settings.vue?macro=true";
import { default as mailchimpGgURtv5fLUXl93RiMPKE_45uy9qPnN4nCbjJBBb3F8388Meta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/mailchimp.vue?macro=true";
import { default as newy1bpuSt1f_451mAEmlXZE1QXNBQFNdi1OJdrNgBRFR_EYMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/tiers/new.vue?macro=true";
import { default as indexfa6pprO9nhz_45uzdKSzFXCrhUjA8ZeC_45A9rD4vYPzZr4Meta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/tiers/index.vue?macro=true";
import { default as newWQwJKiN7zw5GEAdGm7PFJbAmepsoWme4F_mKq3kq_45EcMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/updates/new.vue?macro=true";
import { default as indexjWx8lVWb7zlALG_45rimLnNs3OvXs68IsuzCrpcs4pLx4Meta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/integrations/index.vue?macro=true";
import { default as klaviyomaj9_du9rIKvhm1BaSNeCJc5Yl9HB33No0d2AWULPrsMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/integrations/klaviyo.vue?macro=true";
import { default as integrationsBT1uAYazdmyWoWgETlV_45BtL3FY2aze00fwry_45PkN65EMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/integrations.vue?macro=true";
import { default as _91slug_93e3mBi1BOElQPHjfBcHNWPmejcU6vc87y2Wv4qzHe6jcMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/tiers/[slug].vue?macro=true";
import { default as newhCXY_45AigcI4430jc9S1Tvkc2IQFTtRLTHPA64OhJIK4Meta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/new.vue?macro=true";
import { default as indexkLvKij482sSSFanZiH_TdXEjfxnAH1f5FlgbW91CBDQMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/updates/index.vue?macro=true";
import { default as _91id_93PHIEGazk1APbIjSM2tAQ_0j4GxFFriFfZRpp2y8yGr8Meta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/campaigns/[id].vue?macro=true";
import { default as _91slug_93tSNMmFGTLStdwZZ0xHft2YSMgjqaRA4Jm8sJIoXzJlEMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/updates/[slug].vue?macro=true";
import { default as indexsulGgMabjd0_pSVHc0GIdVj4QGyKO_45vgJ1Dtr02pQ08Meta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/campaigns/index.vue?macro=true";
import { default as indexHsqaZ0vinSQB3gJNSpncuNhgyjxt62LOALqLayF0krwMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/index.vue?macro=true";
import { default as createwOdGSG3lpNh6TvM8seKJj5MfAogOYNOCKYL1J83zzX0Meta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/campaigns/create.vue?macro=true";
import { default as new_45pollUblc3AUyY0JtM0I_45IQ2Gz2dFaYxtr5q2lNpvVkcLuBkMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/updates/new-poll.vue?macro=true";
import { default as _91id_934_45lQ6cG967bE9mmE4G8gbjoC58OfVv9Ue59Tjew_45r7QMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/edit/[id].vue?macro=true";
import { default as newl_msl_45DyYi7OVUEL3p_450UvmS_45JfWd_45cxNRPyxeb4OxoMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/prizes/new.vue?macro=true";
import { default as _91id_93XFPRy3Wo8FsQJccl0yVFt7nNttUsaJTUt3UwtmJTXmkMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/prizes/edit/[id].vue?macro=true";
import { default as dashboard1j3AH1vKwgumUoJUdSfct29oYy_45h3pOF8Xt2HklJOwcMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/dashboard.vue?macro=true";
import { default as rare_45galairI5Neva4EtsbIybC7JgddmGmauJ0ncRWT_4565VYVm1YMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/rare-gala.vue?macro=true";
import { default as logink8c3pEUv71_qSrl9_J1pCHUkQosI4psatHBQWxihgxgMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/donor/login.vue?macro=true";
import { default as reset_45passwordPMoEslJzZQXL3ylX9HWpMLoEWKZTl1TwNgq6fgwP2UQMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/reset-password.vue?macro=true";
import { default as forgot_45passwordQ4LeRPGzVjcSF6Xtb7nzRcn8PenA_45sHECPMPioI1fAUMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/forgot-password.vue?macro=true";
import { default as callbackJdITOdDqRvGsf5_45hdr0V78Yb5jVFjYXGHs_45b7B1qdnYMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/stripe/callback.vue?macro=true";
import { default as rare_45impact_45testBnhE_315heHPv_45xMAYIubtCEjJhq2MR7hbxrQkbQnfUMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/rare-impact-test.vue?macro=true";
import { default as joinZBZZF9jsv4mQJsmAaTQij_45DoRUr6av6_pzwguTKQCz8Meta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/join.vue?macro=true";
import { default as indexUqVsUINxRRm1fSl2PNrLuATEtNcILXNeYOJj_bs5cBkMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/index.vue?macro=true";
import { default as checkoutBq3r8ehP7DjF6EMSzbI0fJ92B9YO_CWEW_92lhYLtLsMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/checkout.vue?macro=true";
import { default as giveawaysVn2yQuf8yjSXPnSm2drRuRcv8uoSwobdRfqjXXezmBIMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/giveaways.vue?macro=true";
import { default as impact_45feedfttzXz__Zfi7fcAHmpr9DQG0yMK1Zio4JYR_45dMBM6icMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/impact-feed.vue?macro=true";
import { default as sweepstakeskTBMjO5axNDe_45F2NCUhtxbf3_45FANjuyFK1KGPDoXbCYMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/sweepstakes.vue?macro=true";
import { default as our_45partnersLUNnjnOnL9C2Raq047mfxTprEVrJNjejkfcXAorNVgEMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/our-partners.vue?macro=true";
import { default as indexMk18AtoM0yRRaSUapFwFf7zXrQeuHU32Jk_4557qH15CkMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/welcome/index.vue?macro=true";
import { default as donateADJq8AoZM0cwnG5DjPharOsqsHTdSh98qkDPmwFb11sMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/partners/[partnerSlug]/donate.vue?macro=true";
import { default as _91slug_93iM80vcC3rD2h4y8FELhAx2JG5fbgvWLdSexQImS9NqsMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug].vue?macro=true";
import { default as rare_45impact_45selenaRysnxVPWQ0LcmYFMfzIN7Jgd56GebAh6D8wNErp5nXQMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/rare-impact-selena.vue?macro=true";
import { default as indexTAWmnrISkosiWg4V7lnTG6Sc_450MIbzZlIb0PEPPovkIMeta } from "/vercel/path0/packages/ddc-giving-circle/pages/mailchimp/redirect/index.vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/home.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/terms.vue")
  },
  {
    name: "editor",
    path: "/editor",
    meta: { ...(editorC0QRbTI7LnsL9V9TnLs6lNUMPc_DLxNC_455ZJ37ijHUwMeta || {}), ...{"middleware":["require-staff"]} },
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/editor.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/signup.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: { ...(profiler_45ATncfblxG8TF6VeYJXVoHYB5m7LdwgwCPsUSfdfLwMeta || {}), ...{"middleware":"authenticated-donor"} },
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/profile.vue")
  },
  {
    name: dashboard1j3AH1vKwgumUoJUdSfct29oYy_45h3pOF8Xt2HklJOwcMeta?.name,
    path: "/dashboard",
    meta: { ...(dashboard1j3AH1vKwgumUoJUdSfct29oYy_45h3pOF8Xt2HklJOwcMeta || {}), ...{"middleware":["require-staff"]} },
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard.vue"),
    children: [
  {
    name: "dashboard",
    path: "",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-share",
    path: "share",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/share.vue")
  },
  {
    name: "dashboard-prizes",
    path: "prizes",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/prizes.vue")
  },
  {
    name: "dashboard-members",
    path: "members",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/members.vue")
  },
  {
    name: "dashboard-partners",
    path: "partners",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/partners.vue")
  },
  {
    name: "dashboard-settings",
    path: "settings",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/settings.vue")
  },
  {
    name: "dashboard-mailchimp",
    path: "mailchimp",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/mailchimp.vue")
  },
  {
    name: "dashboard-tiers-new",
    path: "tiers/new",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/tiers/new.vue")
  },
  {
    name: "dashboard-tiers",
    path: "tiers",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/tiers/index.vue")
  },
  {
    name: "dashboard-updates-new",
    path: "updates/new",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/updates/new.vue")
  },
  {
    name: integrationsBT1uAYazdmyWoWgETlV_45BtL3FY2aze00fwry_45PkN65EMeta?.name,
    path: "integrations",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/integrations.vue"),
    children: [
  {
    name: "dashboard-integrations",
    path: "",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/integrations/index.vue")
  },
  {
    name: "dashboard-integrations-klaviyo",
    path: "klaviyo",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/integrations/klaviyo.vue")
  }
]
  },
  {
    name: "dashboard-tiers-slug",
    path: "tiers/:slug()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/tiers/[slug].vue")
  },
  {
    name: "dashboard-giveaways-new",
    path: "giveaways/new",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/new.vue")
  },
  {
    name: "dashboard-updates",
    path: "updates",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/updates/index.vue")
  },
  {
    name: "dashboard-campaigns-id",
    path: "campaigns/:id()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/campaigns/[id].vue")
  },
  {
    name: "dashboard-updates-slug",
    path: "updates/:slug()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/updates/[slug].vue")
  },
  {
    name: "dashboard-campaigns",
    path: "campaigns",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/campaigns/index.vue")
  },
  {
    name: "dashboard-giveaways",
    path: "giveaways",
    meta: indexHsqaZ0vinSQB3gJNSpncuNhgyjxt62LOALqLayF0krwMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/index.vue")
  },
  {
    name: "dashboard-campaigns-create",
    path: "campaigns/create",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/campaigns/create.vue")
  },
  {
    name: "dashboard-updates-new-poll",
    path: "updates/new-poll",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/updates/new-poll.vue")
  },
  {
    name: "dashboard-giveaways-edit-id",
    path: "giveaways/edit/:id()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/edit/[id].vue")
  },
  {
    name: "dashboard-giveaways-prizes-new",
    path: "giveaways/prizes/new",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/prizes/new.vue")
  },
  {
    name: "dashboard-giveaways-prizes-edit-id",
    path: "giveaways/prizes/edit/:id()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/dashboard/giveaways/prizes/edit/[id].vue")
  }
]
  },
  {
    name: "rare-gala",
    path: "/rare-gala",
    meta: rare_45galairI5Neva4EtsbIybC7JgddmGmauJ0ncRWT_4565VYVm1YMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/rare-gala.vue")
  },
  {
    name: "donor-login",
    path: "/donor/login",
    meta: logink8c3pEUv71_qSrl9_J1pCHUkQosI4psatHBQWxihgxgMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/donor/login.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/reset-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/forgot-password.vue")
  },
  {
    name: "stripe-callback",
    path: "/stripe/callback",
    meta: {"middleware":["require-staff"]},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/stripe/callback.vue")
  },
  {
    name: "rare-impact-test",
    path: "/rare-impact-test",
    meta: rare_45impact_45testBnhE_315heHPv_45xMAYIubtCEjJhq2MR7hbxrQkbQnfUMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/rare-impact-test.vue")
  },
  {
    name: _91slug_93iM80vcC3rD2h4y8FELhAx2JG5fbgvWLdSexQImS9NqsMeta?.name,
    path: "/subdomain/:slug()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug].vue"),
    children: [
  {
    name: "subdomain-slug-join",
    path: "join",
    meta: joinZBZZF9jsv4mQJsmAaTQij_45DoRUr6av6_pzwguTKQCz8Meta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/join.vue")
  },
  {
    name: "subdomain-slug",
    path: "",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/index.vue")
  },
  {
    name: "subdomain-slug-checkout",
    path: "checkout",
    meta: checkoutBq3r8ehP7DjF6EMSzbI0fJ92B9YO_CWEW_92lhYLtLsMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/checkout.vue")
  },
  {
    name: "subdomain-slug-giveaways",
    path: "giveaways",
    meta: giveawaysVn2yQuf8yjSXPnSm2drRuRcv8uoSwobdRfqjXXezmBIMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/giveaways.vue")
  },
  {
    name: "subdomain-slug-impact-feed",
    path: "impact-feed",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/impact-feed.vue")
  },
  {
    name: "subdomain-slug-sweepstakes",
    path: "sweepstakes",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/sweepstakes.vue")
  },
  {
    name: "subdomain-slug-our-partners",
    path: "our-partners",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/our-partners.vue")
  },
  {
    name: "subdomain-slug-welcome",
    path: "welcome",
    meta: { ...(indexMk18AtoM0yRRaSUapFwFf7zXrQeuHU32Jk_4557qH15CkMeta || {}), ...{"middleware":"authenticated-donor"} },
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/welcome/index.vue")
  },
  {
    name: "subdomain-slug-partners-partnerSlug-donate",
    path: "partners/:partnerSlug()/donate",
    meta: donateADJq8AoZM0cwnG5DjPharOsqsHTdSh98qkDPmwFb11sMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/subdomain/[slug]/partners/[partnerSlug]/donate.vue")
  }
]
  },
  {
    name: "rare-impact-selena",
    path: "/rare-impact-selena",
    meta: rare_45impact_45selenaRysnxVPWQ0LcmYFMfzIN7Jgd56GebAh6D8wNErp5nXQMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/rare-impact-selena.vue")
  },
  {
    name: "mailchimp-redirect",
    path: "/mailchimp/redirect",
    meta: {"middleware":["require-staff"]},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/pages/mailchimp/redirect/index.vue")
  }
]